import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {USER_QUESTION_ANSWER} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('userQuestionAnswers.title'),
                url: USER_QUESTION_ANSWER,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('lesson'),
                        type: 'custom-html',
                        key: 'lesson',
                        isVisible: true,
                        modifier: (lesson) => {
                            return lesson ? lesson.title ? lesson.title : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('lesson'),
                        type: 'custom-html',
                        key: 'lesson',
                        isVisible: true,
                        modifier: (lesson) => {
                            return lesson ? lesson.title ? lesson.title : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-user-question-answer-modal',
                        modalId: 'user_question_answer-modal',
                        url: USER_QUESTION_ANSWER,
                        name: 'edit',
                        modifier: row => this.$can('update_user_question_answer')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'user_question_answer-modal',
                        url: USER_QUESTION_ANSWER,
                        name: 'delete',
                        modifier: row => this.$can('delete_user_question_answer')
                    },
                ],
            }
        }
    }
}
export function isImage(url) {
    return /\.(jpeg|jpg|gif|png|svg|webp)$/i.test(url);
}
